export const trainingFields = [
    'bosr',
    'rnrf',
    'cgdr',
    'hsan',
    'caan',
    'udap',
    'part_two_infant_toddler_or_schoolage',
] as const;

export type FloridaTrainingKeys = (typeof trainingFields)[number];

export type FloridaTrainingFields = {
    [key in FloridaTrainingKeys]?: boolean;
};

export type FloridaTrainingSetState = React.Dispatch<React.SetStateAction<FloridaTrainingFields>>;

export interface FloridaTranscriptVerifyProps {
    checkboxStates: FloridaTrainingFields;
    setCheckboxStates: FloridaTrainingSetState;
    activeWorker: number;
}

export interface GeneralDocumentVerifyProps {
    expirationDate: Date | undefined;
    setExpirationDate: (expirationDate: Date | undefined) => void;
}

export interface MedicalRecordVerifyProps {
    setSignedAt: (signedAt: Date | undefined) => void;
    signedAt: Date | undefined;
}

export interface DocumentVerificationContentProps
    extends FloridaTranscriptVerifyProps,
        GeneralDocumentVerifyProps,
        MedicalRecordVerifyProps {
    medicalRecord: boolean;
    dcfDocument: boolean;
}
